import angular from 'angular';
import { UButtonComponent } from '@updater/angular-common';
import { InsuranceRetentionConfig } from './insurance-retention.config';
import { InsuranceRetentionComponent } from './insurance-retention.component';
import { CardModule } from '../../core';
import {
  StepPageModule,
  UCloudinaryImageDirectives,
} from '../../common/directives';

export const InsuranceRetentionStepModule = angular
  .module('app.steps.insurance-retention', [
    UButtonComponent.name,
    CardModule.name,
    StepPageModule.name,
    UCloudinaryImageDirectives.name,
  ])
  .config(InsuranceRetentionConfig)
  .component('updInsuranceRetention', InsuranceRetentionComponent);
